export default function formatData (str) {
  let data = str.split('-')
  let dataFormat = data[2] + '/' + data[1] + '/' + data[0]
  return dataFormat
}
